// import { sharedPersistedConfig, sharedSlice } from '@features/_shared/store/sharedSlices';
// import { accessPersistedConfig, accessReducer, accessSlice } from '@features/access/state/access.slice';
// import { customerAnalysisPersistedConfig, customerAnalysisSlice } from '@features/customer/state/customer.analysis.slice';
// import { customerPersistedConfig, customerSlice } from '@features/customer/state/customer.slice';
// import { exercisePersistedConfig, exerciseSlice } from '@features/exercise/state/exercise.slice';
// import { workoutSessionPersistedConfig, workoutSessionSlice } from '@features/workout/store/workout.session.slice';
// import { workoutPersistedConfig, workoutSlice } from '@features/workout/store/workout.slice';
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { sharedPersistedConfig, sharedSlice } from 'src/features/_shared/store/sharedSlices';
import { accessPersistedConfig, accessSlice } from 'src/features/access/state/access.slice';
import { customerAnalysisPersistedConfig, customerAnalysisSlice } from 'src/features/customer/state/customer.analysis.slice';
import { customerPersistedConfig, customerSlice } from 'src/features/customer/state/customer.slice';
import { exercisePersistedConfig, exerciseSlice } from 'src/features/exercise/state/exercise.slice';
import { workoutSessionPersistedConfig, workoutSessionSlice } from 'src/features/workout/store/workout.session.slice';
import { workoutPersistedConfig, workoutSlice } from 'src/features/workout/store/workout.slice';

export const rootReducer = combineReducers({
    shared: persistReducer(sharedPersistedConfig, sharedSlice.reducer),
    accessSlice: persistReducer(accessPersistedConfig, accessSlice.reducer),
    exerciseSlice: persistReducer(exercisePersistedConfig, exerciseSlice.reducer),
    workoutSlice: persistReducer(workoutPersistedConfig, workoutSlice.reducer),
    workoutSessionSlice: persistReducer(workoutSessionPersistedConfig, workoutSessionSlice.reducer),
    customerSlice: persistReducer(customerPersistedConfig, customerSlice.reducer),
    customerAnalysisSlice: persistReducer(customerAnalysisPersistedConfig, customerAnalysisSlice.reducer),
});

const persistConfig = {
    key: 'root',
    storage,
    blacklist: ['access', 'shared', 'exercise', 'workout', 'customer', 'customerAnalysis'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
    reducer: {
        reducer: persistedReducer,
    },
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware({
            serializableCheck: false,
        }),
});

export type StoreDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
